import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import '../components/Header/Header.esm.js';
import { useCommonI18nContext } from './I18nProvider.esm.js';
import { AccountDropdownOptionsSettings } from '../components/Header/internals/shared.esm.js';

/* eslint-disable no-console */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* istanbul ignore next */ var DEFAULT_LAYOUT_CONTEXT_VALUE = {};
/* istanbul ignore next */ var LayoutContext = /*#__PURE__*/ createContext(DEFAULT_LAYOUT_CONTEXT_VALUE);
function getAccountDropdownSettings(param) {
    var s = param.s, auth = param.auth, nav = param.nav;
    var _auth_logoutUrl;
    var _obj;
    return _obj = {}, _define_property(_obj, AccountDropdownOptionsSettings.MyAccount, {
        title: s("header.actions.login"),
        url: nav.consumerUrl
    }), _define_property(_obj, AccountDropdownOptionsSettings.Settings, {
        title: s("header.actions.settings"),
        url: "".concat(nav.consumerUrl, "/settings")
    }), _define_property(_obj, AccountDropdownOptionsSettings.Logout, {
        title: s("header.actions.logout"),
        url: (_auth_logoutUrl = auth === null || auth === void 0 ? void 0 : auth.logoutUrl) !== null && _auth_logoutUrl !== void 0 ? _auth_logoutUrl : "/"
    }), _obj;
}
var LayoutProvider = function(param) {
    var auth = param.auth, nav = param.nav, children = param.children;
    var s = useCommonI18nContext().s;
    var value = useMemo(function() {
        return {
            getAccountDropdownSettings: function() {
                return getAccountDropdownSettings({
                    s: s,
                    auth: auth,
                    nav: nav
                });
            }
        };
    }, [
        s,
        auth,
        nav
    ]);
    return /*#__PURE__*/ jsx(LayoutContext.Provider, {
        value: value,
        children: children
    });
};
function useLayoutContext() {
    return useContext(LayoutContext);
}

export { DEFAULT_LAYOUT_CONTEXT_VALUE, LayoutContext, LayoutProvider, getAccountDropdownSettings, useLayoutContext };
